import { HttpClient } from '@angular/common/http';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Injectable } from '@angular/core';
import { WalletSessionPlatformService } from '../services/wallet-session-platform.service';
import { WalletSessionService } from '../services/wallet-session.service';

export const walletSessionServiceFactory = (
  httpClient: HttpClient,
  appConfig: AppConfigSettings,
): WalletSessionService => {
  return new WalletSessionPlatformService(httpClient, appConfig);
};

@Injectable({
  providedIn: 'root',
})
export class WalletSessionServiceFactory {
  constructor(
    private httpClient: HttpClient,
    private appConfig: AppConfigSettings,
  ) {}

  create(): WalletSessionService {
    return walletSessionServiceFactory(this.httpClient, this.appConfig);
  }
}
